import LoadCellWiringGuide from './LoadCellWiringGuide'

export default LoadCellWiringGuide
